import {styled} from "@mui/material/styles"
import {Gradient} from "../../../Chevron/component"

const StandardGradient = styled(Gradient, {
    shouldForwardProp: prop => !["templating"].includes(prop as string),
})`
    height: 100%;
    background: ${({theme}) =>
        `linear-gradient(to right, ${theme.uxfabric.components.appBar.navBar.default.backgroundColor}, rgba(30, 30, 30, 0) 100%)`};
`

export default StandardGradient
